export interface AiReportDatasetColumn {
    key: string;
    label: string;
}

export interface AiReportDatasetRow {
    id: number;
    dataset_id: number;
    key_value: string;
    row_data: Record<string, string>;
    created_time: string;
    updated_time: string;
}

export interface AiReportDataset {
    id: number;
    created_user_id: number;
    name: string;
    columns: AiReportDatasetColumn[];
    referred_column_key: string;
    row_count?: number;
    rows?: AiReportDatasetRow[];
    created_time: string;
    updated_time: string;
}

export const DATASET_MIN_COLUMNS = 2;
export const DATASET_MAX_COLUMNS = 10;
